import { getLogger } from 'utils/logger';
import { bugsnagClient, bugsnagNotify } from 'utils/crashReporter';

const log = getLogger('app/utils/localStorageEx.js');

class LocalStorageEx {

  setItem = (key, newValue) => {
    try {
      localStorage.setItem(key, newValue);

      const storageEvent = document.createEvent('StorageEvent');
      storageEvent.initStorageEvent('storage',
        false,
        false,
        key,
        localStorage.getItem(key),
        newValue,
        undefined,
        localStorage);

      window.dispatchEvent(storageEvent);
    } catch (e) {
      log.error('Error in LocalStorageEx.setItem', e);
      if (e.name === 'QuotaExceededError') {
        bugsnagNotify(e, (event) => event.addMetadata('debug', { localStorageLength: localStorage.length }));
        localStorage.clear();
      } else {
        bugsnagClient.notify(e);
      }
    }
  };

  removeItem = (key) => {
    try {
      localStorage.removeItem(key);

      const storageEvent = document.createEvent('StorageEvent');
      storageEvent.initStorageEvent('storage',
        false,
        false,
        key,
        localStorage.getItem(key),
        null,
        undefined,
        localStorage);

      window.dispatchEvent(storageEvent);
    } catch (e) {
      log.error('Error in LocalStorageEx.removeItem', e);
      bugsnagNotify(e);
    }
  };

  clear = () => {
    try {
      localStorage.clear();
    } catch (e) {
      log.error('Error in LocalStorageEx.setItem', e);
      bugsnagNotify(e);
    }
  }

  getItem = (keyName) => {
    let item;

    try {
      item = localStorage.getItem(keyName);
    } catch (e) {
      log.error('Error in LocalStorageEx.getItem', e);
      bugsnagNotify(e);
    }

    return item;
  }

}

const localStorageEx = new LocalStorageEx();
export default localStorageEx;

